<!-- 教师备授课活跃排行Top5 -->
<template>
  <div class="active-rank">
      <div class="active-rank-top">
          <div class="title">教师备授课活跃排行Top5</div>
          <!-- <div class="more" @click="goMore">更多 ></div> -->
          <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
      </div>
      <div class="active-rank-tab">
          <div class="name" @click="changeActive(false)" :class="!isActiveLectures ? 'is-active' : ''">备课</div>
          <div class="name" @click="changeActive(true)" :class="isActiveLectures ? 'is-active' : ''">授课</div>
      </div>
      <div class="active-rank-line"></div>
      <div class="active-rank-content">
          <div class="active-rank-list">
              <div class="active-rank-li" v-for="(item,index) in rankList" :key="item.schoolId">
                  <!-- <div class="rank">NO.{{index+1}}</div> -->
                  <div class="rank" :class="index == 0 ? 'one' : index == 1 ? 'two' : index==2 ? 'three':''">NO.{{index+1}}</div>
                  <div class="school-name">{{ item.schoolName }}</div>
                  <div class="rate">
                      <el-progress class="rank-progress" :color="'#2B7FFF'" text-inside :define-back-color="'#00000000'"  :percentage="item.progress" :show-text="false" :stroke-width="16" />
                      <div class="number">{{ item.progress }}%</div>
                  </div>
              </div>
          </div>
      </div>
      <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
      <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
      <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
      <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div> 
</template>

<script>
export default {
  name: 'active-rank',
  components: {
  },
  props:{
      //请求参数
      params: {
          type: Object,
          default: ()=>{}
      },
  },
  data() {
      return {
          //是否选中授课
          isActiveLectures:false,
          rankList:[], 
          //授课应用活跃率排行榜
          lecturesRankList:[
            {
              schoolName:"实验中学",
              progress:98,
              id:1
            },
            {
              schoolName:"北京路中学",
              progress:97,
              id:2
            },
            {
              schoolName:"赵家庄实验二中",
              progress:86,
              id:3
            },
            {
              schoolName:"高新区实验中学",
              progress:86,
              id:4
            },
            {
              schoolName:"华维文澜中学",
              progress:70,
              id:5
            }
          ],
          //备课应用活跃率排行榜
          prepareLessonsRankList:[
            {
              schoolName:"实验中学",
              progress:98,
              id:1
            },
            {
              schoolName:"北京路中学",
              progress:97,
              id:2
            },
            {
              schoolName:"赵家庄实验二中",
              progress:86,
              id:3
            },
            {
              schoolName:"高新区实验中学",
              progress:86,
              id:4
            },
            {
              schoolName:"华维文澜中学",
              progress:70,
              id:5
            }
          ]
      }
  },
  methods: {
      /**
       * @name 切换备课授课
       */
      changeActive(isActiveLectures){
          this.isActiveLectures = isActiveLectures;
          if(isActiveLectures){
              this.rankList = JSON.parse(JSON.stringify(this.lecturesRankList))
          }else{
              this.rankList = JSON.parse(JSON.stringify(this.prepareLessonsRankList))
          }
      },

      /**
       * @name 跳转更多
       */
      goMore(){

      },
  },
  mounted(){
    this.rankList = JSON.parse(JSON.stringify(this.prepareLessonsRankList))
  },
}
</script>

<style lang="scss" scoped>
.active-rank{
  width: 100%;
  height: 330px;
  padding: 0 15px;
  border: 1px solid #053882;
  position: relative;
  margin-bottom: 20px;
//   background: rgba(6,17,52,0.8);
  .active-rank-top{
      position: relative;
      text-align: center;
      margin-bottom: 20px;
      .title{
          display: inline-block;
          padding: 9px 22px 8px 17px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #D0E7FE;
          line-height: 20px;
          position: relative;
          z-index: 2;
      }
      .more{
          display: inline-block;
          position: absolute;
          top: 0px;
          right: 0px;
          height: 100%;
          line-height: 44px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #359AFF;
          cursor: pointer;
      }
      .title-bg{
          width: auto;
          height: 100%;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
      }
  }
  .active-rank-tab{
      text-align: left;
      .name{
          margin: 0 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid transparent;
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #BFD5ED;
          display: inline-block;
          cursor: pointer;
      }
      .is-active{
          color: #2773E6;
          border-color: #2773E6;
      }
  }
  .active-rank-line{
      width: 100%;
      height: 1px;
      background-color: rgba(112, 138, 204, 0.2);
      margin-top: -1px;
  }
  .active-rank-content{
      width: 100%;
      margin-top: 25px;
      margin-bottom: 21px;
      .active-rank-list{
          width: 100%;
          .active-rank-li{
              width: 100%;
              height: 28px;
              display: flex;
              align-items: center;
              margin-bottom: 14px;
              .rank{
                font-size: 14px;
                font-family: DingTalk JinBuTi;
                font-weight: 400;
                color: #6EA0D3;
                display: inline-flex;
                width: 60px;
                align-items: center;
                justify-content: center;
                height: 28px;
                // padding: 8px 10px;
                text-align: left;
                background-size: 100% 100%;
                background: url('../../../assets/images/sydataboard/four.png') no-repeat;
              }
              .one{
                background: url('../../../assets/images/sydataboard/one.png') no-repeat;
                color: #FF5B74;
              }
              .two{
                background: url('../../../assets/images/sydataboard/two.png') no-repeat;
                color: #CEB151;
              }
              .three{
                background: url('../../../assets/images/sydataboard/three.png') no-repeat;
                color: #27CDE6;
              }
              .school-name{
                  width: 100px;
                  text-align: left;
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #6EA0D3;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
              }
              .rate{
                  width: calc(100% - 165px);
                  display: flex;
                  margin-left: 5px;
                  .rank-progress{
                      width: calc(100% - 75px);
                  }
                  .number{
                      margin-left: 5px;
                      display: inline-block;
                      width: 70px;
                      font-size: 14px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #7ABFDB;
                      text-align: right;
                      line-height: 16px;
                  }
              }
          }
          .active-rank-li:last-child{
              margin-bottom: 0;
          }
      }
  }
  .top-left{
      position: absolute;
      top: 0;
      left: 0;
      width: 14px;
      height: 14px;
  }
  .top-right{
      position: absolute;
      top: 0;
      right: 0;
      width: 14px;
      height: 14px;
  }
  .left-bottom{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 14px;
      height: 14px;
  }
  .right-bottom{
      position: absolute;
      bottom: 0;
      right: 0;
      width: 14px;
      height: 14px;
  }
}
</style>
<style lang="scss">
.active-rank{
  .active-rank-content{
      .active-rank-list{
          .active-rank-li{
              .rate{
                  .el-progress-bar{
                      .el-progress-bar__outer{
                          background-color: transparent;
                          border-radius: 0;
                          .el-progress-bar__inner{
                              border-radius: 0;
                          }
                      }
                      .el-progress__text{
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #6EA0D3;
                      }
                  }
              }
          }
      }
  }
}
</style>